import { Component, OnInit, Output, EventEmitter, Input, OnChanges, OnDestroy } from '@angular/core';
import { FormGroup, Validators, FormBuilder, FormArray, FormControl } from '@angular/forms';
import { ConstantsService, LookupsService, AccountService, SessionService, GasApplianceModel,
   RequestServiceModelView} from '@app/base/core';
import { SocoHttpService } from '@app/soco/http';
import { BuilderService } from '@app/modules/builder';
import { UspsService } from '@app/shared/services';
import { HttpClient } from '@angular/common/http';
import { compareObjects, focusFirstInvalidField, phoneNumber, triggerFormValidation } from '@app/shared/functions';
import { GridDataResult, DataStateChangeEvent, RowArgs, SelectAllCheckboxState } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { DatePipe } from '@angular/common';
import { SocoConfigurationService } from '@app/soco/configuration/soco-configuration.service';
import { takeWhile } from 'rxjs/operators';
import { Subscription } from 'rxjs';

const moment = require('moment');
require('moment-weekday-calc');

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'service-new-request',
  templateUrl: './service.new.request.component.html',
  styleUrls: ['./service.new.request.component.css']
})
// Service Request Component implements service request Form
export class ServiceNewRequestComponent implements OnInit, OnChanges, OnDestroy {
  public dateOptions: any = {
    alwaysShowCalendars: false,
    singleDatePicker: true,
    autoUpdateInput: true,
    showDropdowns: true,
    parentEl: '.dateClass .col-md-6',
    minDate: moment().addWorkdays(21),
    isInvalidDate: (date) => (date.day() === 0 || date.day() === 6)
};
public killsubscribe: boolean;
public postServiceReqSubscription: Subscription;
  // Constructor with the variables declared for necessary services to be used across the component.
  constructor(public constantsSvc: ConstantsService, public builderSvc: BuilderService, private httpC: HttpClient,
     public lookupSvc: LookupsService, public socoHttp: SocoHttpService, private usps: UspsService,
      private datePipe: DatePipe, private config: SocoConfigurationService,
    public accountSvc: AccountService, public sessionSvc: SessionService, private formBuilder: FormBuilder) {
    this.userName = this.accountSvc.account.user.username;
  }
  // Global variables to be used across different functions.
  addressValidationError: any;
  addressToValidate: any;
  validatedAddress: any;
  _lotData: RequestServiceModelView[];
  applianceData: GasApplianceModel;
  streetname: any;
  info: string;
  streetnumber: number;
  city: string;
  state: any;
  zipcode: string;
  county: any;
  applianceCountS = true;
  builderServiceDetailsForm: FormGroup;
  userName: string;
  myVal = false;
  newVal = true;
  selectedFile = null;
  selectedIDsforSubDivision: any[] = [];
  public btuLoadVal = 'BTU Load Value (Optional)';
  public rowValue: string;
  AttachmentList: string[] = [];
  public SearchResultsGridView: GridDataResult;
  public take = 5;
  public kendostate: State = {
    skip: 0,
    take: 5,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  // The Output event emits the event to update the grid in parent Service request component
  @Output() updateGrid = new EventEmitter<any>();

  // The input variable accepts the services grid click event row data,
  // The row data is assigned to respective columns in the form.
  @Input() set lotdata(data: RequestServiceModelView[]) {
    this._lotData = data;
  }
  ngOnDestroy() {
    if ($('#address_validation_modal').is(':visible')) {
      $('#address_validation_modal').modal('hide');
    }
    this.killsubscribe = false;
    if (this.postServiceReqSubscription) {
      this.postServiceReqSubscription.unsubscribe();
  }
  }
// The initialization of the  Form Group, which includes the disabled fields and validations.
  ngOnInit() {
    this.killsubscribe = true;
    this.applianceData = new GasApplianceModel();
    this.builderServiceDetailsForm = this.formBuilder.group({
      companyName: [{ value: null, disabled: true }],
      contactNumber1: [{ value: null, disabled: true }],
      contactNumberExtension1: [{ value: null, disabled: true }],
      email: [{ value: null, disabled: true }],
      streetNumber: [null, [Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]],
      unitNumber: [null, [Validators.pattern(this.constantsSvc.alphaNumericPattern)]],
      city: [{ value: null, disabled: true }],
      state: [{ value: null, disabled: true }],
      zipCode: [{ value: null, disabled: true }],
      district: [null],
      appliancesForSubdivision: new FormArray([new FormGroup({
        defaultAppliance: new FormControl(null, [Validators.required]),
        defaultApplianceOther: new FormControl(null),
        quantity: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)]),
        defaultValue: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPatternwithZero)]),
        existingLoad: new FormControl(false)
      }
      )]
      ),
      streetName: [null,  Validators.required],
      plannedDateModal: [null, Validators.pattern(this.constantsSvc.dateValidator)],
      deliveryPressure: [null],
      subdivisionApproximateSquareFootage: [null],
      pCompanyName: [null],
      contactPerson: [null],
      pPhoneNumber: [null],
      firstName: [null],
      lastName: [null],
      contactNumber:  [null, [
            Validators.required,
             Validators.pattern(this.constantsSvc.phoneNumberPattern)
           ]],
      contactNumberExtension:  [null, Validators.pattern(this.constantsSvc.phoneNumberExtensionPattern)],
      email1:  [null, Validators.pattern(this.constantsSvc.emailPattern)],
      other : [null]
    });
  }

  //  On changes to the @input lotData value, The function detects the input from grid click,
  // And assign the grid details to form. Based on the lot data for city and state make the web api call to get
  //  realted  city lookups
  ngOnChanges() {
    this.lookupSvc.commonLookupsLoaded$.subscribe(isloaded => {
       if (isloaded && this._lotData !== undefined) {
        this.builderServiceDetailsForm.reset();
        this.builderSvc.GetLots(this._lotData[0].grId, this._lotData[0].builderId).subscribe(result2 => {
          const tempList: any = [];
        for (const i of result2.data) {
          if (i.lotNumber === this._lotData[0].lotNumber) {
            tempList.push(i);
          }
        }
        this.builderSvc.getSubsidiaryInfo([tempList[tempList.length - 1].builderId]).subscribe(result => {
          this.builderServiceDetailsForm.patchValue({
          companyName : result.data[0].companyName,
          email : result.data[0].email,
          contactNumber1 : result.data[0].builderAddresses.contactName1Phone,
          contactNumberExtension1 : result.data[0].builderAddresses.contactName1Extn
        });
      });
    });
      this.socoHttp.showPleaseWait('Processing.', 'ContainerAwaiter4');
      const lotdetails = this._lotData[0];
      console.log(lotdetails);
      this.builderServiceDetailsForm.patchValue({
        firstName: lotdetails.applicantContactName1,
        lastName: lotdetails.applicantContactName2,
        contactNumber: lotdetails.applicantPhoneNumber,
        contactNumberExtension: lotdetails.applicantPhoneExtension,
        deliveryPressure: (lotdetails.deliveryPressure != null && this.lookupSvc.deliveryPressure !== undefined)
          ? this.lookupSvc.deliveryPressure.find(a => a.itemName === lotdetails.deliveryPressure) : null,
        email1: lotdetails.applicantEmail,
        zipCode: lotdetails.zip,
        subdivisionApproximateSquareFootage: lotdetails.heatedSquareFootage,
        email: this.accountSvc.account.user.email,
        unitNumber: lotdetails.unitNo,
        other : lotdetails.otherDeliveryPressure !== null ? lotdetails.otherDeliveryPressure : null,
        plannedDateModal : lotdetails.serviceNeededBy != null ? this.datePipe.transform(lotdetails.serviceNeededBy, 'MM/dd/yyyy') : null
      });
      this.info = lotdetails.address;
      this.streetnumber = lotdetails.streetNo;
      this.city = lotdetails.city;
      this.state = lotdetails.stateCd;
      this.zipcode = lotdetails.zip;
      this.streetname = lotdetails.streetName;
      // passing the state and city and county id to check for the address.
      if (this.state != null && this.city != null) {
        this.lookupSvc.loadServiceAddressLookups(this.state, this.city, null);

        const subscription = this.lookupSvc.serviceAddressLookupsLoaded$.subscribe(isLoaded => {
           if (isLoaded) {
            if (subscription !== undefined) {
              subscription.unsubscribe();
            }
            this.socoHttp.hidePleaseWait('ContainerAwaiter4');
            this.state = this.lookupSvc.serviceState.find(x => x.id.toUpperCase() === this.state);
            const ab = (this.lookupSvc.serviceCity.find(x => x.itemName.toUpperCase() === this.city.toUpperCase()));
            if (ab !== undefined && ab.itemName === this.city) {
              this.city = ab.itemName;
            }
            this.builderServiceDetailsForm.patchValue({
              streetNumber: this.streetnumber,
              streetName: this.streetname,
              city: this.city,
              state: this.state,
              zipCode: this.zipcode,
            });
          }
        });
      } else {
        this.builderServiceDetailsForm.patchValue({
          streetNumber: this.streetnumber,
          streetName: this.streetname,
          city: this.city,
          state: this.state != null ? this.lookupSvc.states.find(a => a.id === this.state) : null,
          zipCode: this.zipcode,
        });
      this.socoHttp.hidePleaseWait('ContainerAwaiter4');
      }
      this.builderServiceDetailsForm.updateValueAndValidity();
    }
  });
}

  // When user clicks on submit if the form data is valid it is assigned to a modal of type requestServiceModel.
  // Else a swal alert is shown to fill in the incorrect/empty fields.
  OnSubmit() {
    const lotData = this._lotData[0];

    //CXCO-1909 : Commenting out to make the attachment non mandatory when requesting service
    /*if (lotData.stateCd === 'VA') {
      if ( this.myVal === true) {
        this.newVal = true;
      } else {
        this.newVal = false;
      }
    }*/

    if (this.builderServiceDetailsForm.controls['deliveryPressure'].valid &&
     this.builderServiceDetailsForm.controls['deliveryPressure'].value['itemName'] === '2 #') {
      this.builderServiceDetailsForm.controls['pCompanyName'].setValidators(Validators.required);
      this.builderServiceDetailsForm.controls['contactPerson'].setValidators(Validators.required);
      this.builderServiceDetailsForm.controls['pPhoneNumber'].setValidators(Validators.required);
      this.builderServiceDetailsForm.controls['pCompanyName'].updateValueAndValidity();
      this.builderServiceDetailsForm.controls['contactPerson'].updateValueAndValidity();
      this.builderServiceDetailsForm.controls['pPhoneNumber'].updateValueAndValidity();
      this.builderServiceDetailsForm.updateValueAndValidity();
    } else {
      this.builderServiceDetailsForm.controls['pCompanyName'].clearValidators();
      this.builderServiceDetailsForm.controls['contactPerson'].clearValidators();
      this.builderServiceDetailsForm.controls['pPhoneNumber'].clearValidators();
      this.builderServiceDetailsForm.controls['pCompanyName'].updateValueAndValidity();
      this.builderServiceDetailsForm.controls['contactPerson'].updateValueAndValidity();
      this.builderServiceDetailsForm.controls['pPhoneNumber'].updateValueAndValidity();
      this.builderServiceDetailsForm.updateValueAndValidity();
    }
    if (this.builderServiceDetailsForm.valid) {
      const lotSubmitData = this._lotData[0];
      lotSubmitData.applicantContactName1 = this.builderServiceDetailsForm.controls['firstName'].value;
      lotSubmitData.applicantContactName2 = this.builderServiceDetailsForm.controls['lastName'].value;
      lotSubmitData.applicantPhoneNumber = phoneNumber(this.builderServiceDetailsForm.controls['contactNumber'].value);
      lotSubmitData.applicantPhoneExtension = this.builderServiceDetailsForm.controls['contactNumberExtension'].value;
      lotSubmitData.address =
        (this.builderServiceDetailsForm.getRawValue().streetNumber +
          ' ' + this.builderServiceDetailsForm.getRawValue().streetName) + ','
        + this.builderServiceDetailsForm.getRawValue().city + ','
        + this.builderServiceDetailsForm.getRawValue().state.id + ' '
        + this.builderServiceDetailsForm.getRawValue().zipCode;
      lotSubmitData.city = this.builderServiceDetailsForm.controls['city'].value;
      lotSubmitData.stateCd = this.builderServiceDetailsForm.controls['state'].value.id;
      lotSubmitData.heatedSquareFootage = this.builderServiceDetailsForm.controls['subdivisionApproximateSquareFootage'].value !== null
      ? this.builderServiceDetailsForm.controls['subdivisionApproximateSquareFootage'].value : null;
      lotSubmitData.zip = this.builderServiceDetailsForm.controls['zipCode'].value;
      lotSubmitData.streetName = this.builderServiceDetailsForm.controls['streetName'].value;
      lotSubmitData.streetNo = this.builderServiceDetailsForm.controls['streetNumber'].value;
      lotSubmitData.lotStatus = 'SR';
      lotSubmitData.lotStatusUpdatedBy = this.userName;
      lotSubmitData.lotStatusUpdatedDate =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      lotSubmitData.recUpdateDttm =  this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      lotSubmitData.recCreateUsrId = this.userName;
      lotSubmitData.deliveryPressure = this.builderServiceDetailsForm.controls['deliveryPressure'].value['itemName'];
      lotSubmitData.plumberCompanyName = this.builderServiceDetailsForm.controls['pCompanyName'].value;
      lotSubmitData.plumberContactName = this.builderServiceDetailsForm.controls['contactPerson'].value;
      lotSubmitData.plumberContactNo = phoneNumber(this.builderServiceDetailsForm.controls['pPhoneNumber'].value).length > 20
        ? null : phoneNumber(this.builderServiceDetailsForm.controls['pPhoneNumber'].value);
      lotSubmitData.applicantEmail = this.builderServiceDetailsForm.controls['email1'].value;
      lotSubmitData.unitNo = this.builderServiceDetailsForm.controls['unitNumber'].value;
      lotSubmitData.serviceNeededBy = this.builderServiceDetailsForm.controls['plannedDateModal'].value;
      if (this.selectedFile !== null) {
        const fd = new FormData();
        fd.append('file', this.selectedFile, this.selectedFile.name);
        fd.append('grId', lotSubmitData.grId.toString());
        this.httpC.post(this.accountSvc.account.apiInfo.webApiBaseUrl + 'Lots/UploadAttachment?WrSummaryId=' + lotSubmitData.id, fd
        ).subscribe(data => {
          console.log(data);
          }, error => {
            console.log(error);
          });
      }
      for (const appArr of this.builderServiceDetailsForm['controls'].appliancesForSubdivision['controls']) {
        const gasAppliance = this.applianceData;
      gasAppliance.applianceCd = appArr.controls['defaultAppliance'].value['id'];
      gasAppliance.applianceDesc = appArr.controls['defaultAppliance'].value['itemName'];
      gasAppliance.loadValue = +appArr.controls['defaultValue'].value;
      gasAppliance.quantity = appArr.controls['quantity'].value;
      gasAppliance.recCreatedBy = this.userName;
      gasAppliance.recUpdatedBy = this.userName;
      gasAppliance.recUpdatedDttm = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      gasAppliance.recCreatedDttm = this.datePipe.transform(new Date(), 'dd-MMM-yy HH:mm:ss', this.constantsSvc.TimeZone);
      gasAppliance.wrSummaryId = lotSubmitData.id;
      gasAppliance.applianceOthers = appArr.controls['defaultApplianceOther'].value !== null
      ? appArr.controls['defaultApplianceOther'].value : null;
      this.builderSvc.addAppliance(gasAppliance).subscribe(result => {
          this.builderServiceDetailsForm.patchValue({
            quantity: result.data.quantity
          }); });
      }
      lotSubmitData.otherDeliveryPressure = this.builderServiceDetailsForm.controls['other'].value !== null
      ? this.builderServiceDetailsForm.controls['other'].value : null;
      this.socoHttp.showPleaseWait('Processing', 'ContainerAwaiter4');
      this.postServiceReqSubscription = this.builderSvc.PostServiceRequestBylotId(lotSubmitData).subscribe(result => {
        this.builderServiceDetailsForm.patchValue({
          firstName: result.data.applicantContactName1,
          lastName: result.data.applicantContactName2,
          contactNumber: result.data.applicantPhoneNumber,
          contactNumberExtension: result.data.applicantPhoneExtension
        });
      this.socoHttp.hidePleaseWait('ContainerAwaiter4');
      $('#modal_request_service').modal('hide');
      swal(this.constantsSvc.serviceRequestSwal, '', this.constantsSvc.successSwal);
      this.builderServiceDetailsForm.reset();
      this.builderServiceDetailsForm.updateValueAndValidity();
      this.updateGrid.emit('true');
      },
      (error) => {
        swal(this.constantsSvc.errorSwal1, this.constantsSvc.postRequestFail, this.constantsSvc.errorSwal);
      });
    } else {
      triggerFormValidation(this.builderServiceDetailsForm);
      focusFirstInvalidField(this.builderServiceDetailsForm);
      this.socoHttp.hidePleaseWait('ContainerAwaiter4');
    }
  }

  // USPS Validation involves gre-address-validation custom component to pass the data to component to display suggested address.
  // aganist the user entered address.
  validateAddress() {
    this.Modalpopupfunction();
    this.addressToValidate = {
      street: (this.builderServiceDetailsForm.getRawValue().streetNumber +
        ' ' + this.builderServiceDetailsForm.getRawValue().streetName).toUpperCase(),
      city: this.builderServiceDetailsForm.getRawValue().city.toUpperCase(),
      state: this.builderServiceDetailsForm.getRawValue().state.id.toUpperCase(),
      zip: this.builderServiceDetailsForm.getRawValue().zipCode
    };
    if (this.addressToValidate) {
      this.usps.GetValidatedAddress(this.addressToValidate, (result) => {
        if (result.Error) {
          this.addressValidationError = result.Error.Description;
        } else {
          this.validatedAddress = result;
        }

        if (!compareObjects(this.addressToValidate, this.validatedAddress)) {
          $('#address_validation_modal').modal({ show: true });
        }
      });
      return false;
    }
  }

  // select Appliance
  onApplianceSelected(item: any, appArr: FormGroup, subArr: FormGroup) {
    this.btuLoadVal = this.constantsSvc.btuLoadOption;
    appArr.controls['defaultValue'].reset(null);
    appArr.controls['defaultValue'].clearValidators();
    appArr.controls['defaultApplianceOther'].reset(null);
    appArr.controls['defaultApplianceOther'].clearValidators();
    if (item['itemName'].toUpperCase() === this.constantsSvc.other) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultApplianceOther'].setValidators(
        Validators.required
      );
      appArr.controls['defaultValue'].setValidators(
        Validators.pattern(this.constantsSvc.numericPatternwithZero)
      );
      appArr.controls['defaultApplianceOther'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
    } else if ((item['itemName'] === this.constantsSvc.poolHeater) || (item['itemName'] === this.constantsSvc.standbyGenerator)) {
      this.btuLoadVal = this.constantsSvc.btuLoadOption;
      appArr.controls['defaultValue'].clearValidators();
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultValue'].setValidators(
        Validators.pattern(this.constantsSvc.numericPatternwithZero)
      );
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
    } else {
      
        this.btuLoadVal = this.constantsSvc.btuLoad;
        const homeSqFt = subArr.controls['subdivisionApproximateSquareFootage'].value;
        const requestType = item.usageType.toUpperCase() ==='RESIDENTIAL' ? 'RES':'COMM';
      
        const loadValue = this.lookupSvc.wrLoadArmLkp.filter(load => 
          load.loadTypeCode === item.id && load.resiComm === requestType &&
          ((load.minSqFTG === null || load.minSqFTG <= homeSqFt) &&
          (load.maxSqFTG === null || load.maxSqFTG >= homeSqFt))
        );

      if(loadValue.length > 0)
      {
        appArr.controls['defaultValue'].setValue(loadValue[0]['itemName']);
        }

      appArr.controls['defaultApplianceOther'].reset(null);
      appArr.controls['defaultApplianceOther'].clearValidators();
      appArr.controls['defaultValue'].setValidators([
        Validators.required,
        Validators.pattern(this.constantsSvc.numericPatternwithZero)
      ]);
      appArr.controls['defaultValue'].updateValueAndValidity({
        onlySelf: true
      });
    }
    appArr.updateValueAndValidity();
  }

onFileSelected(event) {
  this.myVal = true;
  this.newVal = true;
  this.selectedFile = <File>event.target.files[0];
}
  // Binding data on statechange
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.take = state.take;
  }

  // Attachment Selection
  selectionChange(ev: any) {
    if (ev.selectedRows.length !== 0) {
      for (let i = 0; i < ev.selectedRows.length; i++) {
        this.AttachmentList.push(ev.selectedRows[i].dataItem.name);
      }
    } else {
      for (let i = 0; i < ev.deselectedRows.length; i++) {
        this.AttachmentList.splice(ev.deselectedRows[i].dataItem.name, 1);
      }
    }
    this.rowValue = ev.index;
  }

  public mySelectionKey(context: RowArgs): string {
    return context.dataItem.ProductName + ' ' + context.index;
  }

  // Modalpopupfunctionality for the nested modalpopup ui change
  private Modalpopupfunction() {
    setTimeout(() => {
      $('#address_validation_modal').modal({
        show: true
      });
      $('#address_validation_modal').on('show.bs.modal', '.modal', function (event) {
        const zIndex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function () {
          $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
      });
      $('#address_validation_modal').on('hidden.bs.modal', '.modal', function () {
        $('.modal:visible').length && $('#address_validation_modal').removeClass('modal-open');
      });
      $(document).on('hidden.bs.modal', '.modal', function () {
        $('.modal:visible').length && $(document.body).addClass('modal-open');
      });
      $('modal_request_service').prepend($('#address_validation_modal'));
    }, 2);
  }

  //  To emit and event using the @output with UpdateGridData() to refresh the service request component.
  updateGridData() {
    this.updateGrid.emit('true');
  }

  // To validate the selected addresss is same as user input address.
  // The function is called on the gre-address-validation.
  getAddressFromModal(selectedAddress) {
    // Address to validate is same as validated one.
    if (!compareObjects(this.addressToValidate, selectedAddress)) {
      this.builderServiceDetailsForm.patchValue(
        {
          streetName: selectedAddress.street.substr(selectedAddress.street.indexOf(' ') + 1),
          streetNumber: selectedAddress.street.split(' ')[0]
        });
    }
    $('#address_validation_modal').modal('hide');
    this.builderServiceDetailsForm.updateValueAndValidity();
  }

  // When the address given by the user is incomplete and USPS modal is to be closed
  // Modal Change event event is called on the gre-address-validation.
  modalChangeMailingAddress() {
    $('#address_validation_modal').modal('hide');
    focusFirstInvalidField(this.builderServiceDetailsForm);
  }

   // On click of cancel event update the Grid data and reset the FromGroup
   OnClose() {
    this.updateGridData();
    this.builderServiceDetailsForm.reset();
  }

   // To add appliances for Subdivision
   addAppliancesforSubDivision(element) {
    const formArray = <FormArray>element.get('appliancesForSubdivision');
    formArray.push(
      new FormGroup({
        defaultAppliance: new FormControl(null, [Validators.required]),
        defaultApplianceOther: new FormControl(null),
        quantity: new FormControl('', [
          Validators.required,
          Validators.pattern(this.constantsSvc.numericPattern)
        ]),
        defaultValue: new FormControl('', [
          Validators.pattern(this.constantsSvc.numericPatternwithZero)
        ])
      })
    );
    if (formArray.length > 49) {
      this.applianceCountS = false;
    }
  }

  // Delete appliances for subdivision premise
  deleteApplianceforSubDivision(element) {
    const control = <FormArray>element.get('appliancesForSubdivision');
    if (this.selectedIDsforSubDivision.length === 0) {
      swal(this.constantsSvc.premiseSwal1, this.constantsSvc.premiseSwal2);
    }
    this.selectedIDsforSubDivision.sort((a, b) => b - a);
    this.selectedIDsforSubDivision.forEach(function (index) {
      control.removeAt(index);
    });
    if (control.length < 50) {
      this.applianceCountS = true;
    }
    this.selectedIDsforSubDivision = [];
  }

  // selected ID's of appliances to delete
  selectIDforSubDivision(id, event: any) {
    if (event.target.checked) {
      this.selectedIDsforSubDivision.push(id);
    } else if (!event.target.checked) {
      const index = this.selectedIDsforSubDivision.indexOf(id);
      this.selectedIDsforSubDivision.splice(index, 1);
    }
  }

  // Function to display other text box if user selected Others as  Delivery Pressure, and to hide the other text box
  // if user selected anything other than other.
  onStateChange(data: any) {
    if (data !== undefined && data['itemName'].toUpperCase() === this.constantsSvc.other ) {
      this.builderServiceDetailsForm.controls['other'].setValidators(Validators.required);
      this.builderServiceDetailsForm.updateValueAndValidity();
    } else {
      this.builderServiceDetailsForm.controls['other'].clearValidators();
      this.builderServiceDetailsForm.controls['other'].reset();
      this.builderServiceDetailsForm.updateValueAndValidity({
        onlySelf: true
        });
    }
  }
}

